import {
    FACETS_REQUEST,
    FACETS_FAILURE,
    FACETS_SUCCESS,
    FILTER_UPDATED,
    SEARCH_TERM_UPDATED,
    FILTERS_SET_FROM_URL,
    QUERY_SET_FROM_URL,
    SEARCH_MODE_ENABLED,
    SEARCH_MODE_DISABLED,
    MAP_SHOWN,
    MAP_HIDDEN,
    SEARCH_CLEARED,
    PAGE_CHANGED,
    SET_SEARCH_DATA,
    SET_LIST_CACHE,
    SET_SELECTED_LIST,
    SET_TOTAL_HITS,
} from '../actions/types';

const initialState = {
    loading: true,
    facetsLoading: true,
    searchMode: null,
    mapMode: false,
    page: 0,
    perPage: 12,
    nbHits: null,
    totalPages: null,
    facets: null,
    query: '',
    filters: {
        educator_ref: null,
        category_ref: null,
        level: null,
        delivery: null,
        price: null,
    },
    layout: 'grid',
    listCache: [],
    selectedList: null,
};

export default function search(state = initialState, action) {
    switch (action.type) {
        case FACETS_REQUEST:
            return {
                ...state,
                facetsLoading: true,
            };
        case FACETS_SUCCESS:
            return {
                ...state,
                facets: action.payload,
                facetsLoading: false,
            };
        case FACETS_FAILURE:
            return {
                ...state,
                loading: false,
                facetsLoading: false,
            };
        case FILTER_UPDATED:
            return {
                ...state,
                filters: { ...state.filters, [action.payload.filter]: action.payload.values },
            };
        case SEARCH_TERM_UPDATED:
            return {
                ...state,
                query: action.payload,
            };
        case FILTERS_SET_FROM_URL:
            return {
                ...state,
                filters: { ...state.filters, ...action.payload },
            };
        case QUERY_SET_FROM_URL:
            return {
                ...state,
                query: action.payload,
            };
        case SEARCH_MODE_ENABLED:
            return {
                ...state,
                searchMode: true,
            };
        case SEARCH_MODE_DISABLED:
            return {
                ...state,
                searchMode: false,
            };
        case MAP_SHOWN:
            return {
                ...state,
                mapMode: true,
            };
        case MAP_HIDDEN:
            return {
                ...state,
                mapMode: false,
            };
        case SEARCH_CLEARED:
            return {
                ...state,
                searchMode: false,
                query: '',
                page: 0,
                filters: {
                    category_name: null,
                    delivery: null,
                    price: null,
                    list_refs: null,
                },
            };
        case PAGE_CHANGED:
            return {
                ...state,
                page: action.payload,
            };
        case SET_SEARCH_DATA:
            return {
                ...state,
                ...action.payload,
            };
        case SET_TOTAL_HITS:
            return {
                ...state,
                nbHits: action.payload,
            };
        case SET_LIST_CACHE:
            return {
                ...state,
                listCache: action.payload,
            };

        case SET_SELECTED_LIST:
            return {
                ...state,
                selectedList: action.payload,
            };

        default:
            return state;
    }
}
